import { gql } from '@apollo/client';

export const PROCESS_CLEARANCE_EXCEL = gql`
  mutation ProcessClearanceExcel($input: ProcessClearanceExcelInput!) {
    processClearanceExcel(input: $input) {
      taskNo
      totalCount
    }
  }
`;

export interface ProcessClearanceExcelInput {
  objectKey: string;
  filename: string;
}

export interface ProcessClearanceExcelResponse {
  processClearanceExcel: {
    taskNo: string;
    totalCount: number;
  };
}
